/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import APM from '../APM';
import {IPerformanceMonitor, MonitorCategory} from '../types/types';
import PerformanceMonitor from './PerformanceMonitor';

/**
 * Defines the Page Performance Monitor implementation which is used for measuring
 * the Performance of individual Pages within an Application.
 *
 * The `PagePerformanceMonitor` instance is a singleton (as there is only ever one
 * page loaded during a session). Clients can simply import this module and invoke
 * the `start` method to begin monitoring a page.
 *
 * ```typescript
 *   import PagePerformanceMonitor from '@ion/core/src/apm/PagePerformanceMonitor';
 * ```
 */
class PagePerformanceMonitor extends PerformanceMonitor {
  constructor() {
    super(MonitorCategory.Page);
  }
}

/**
 * Provides the single point of entry for referencing the `PagePerformanceMonitor`
 * instance.
 */
const getMonitor = (() => {
  let instance: IPerformanceMonitor;
  return (): IPerformanceMonitor => {
    if (APM.isEnabled) {
      if (!instance) {
        instance = new PagePerformanceMonitor();
      }
    } else {
      instance = null;
    }
    return instance;
  };
})();

export default getMonitor;
